import e, { OPTIONS as T } from "../managers/braze-instance.js";
import ot from "../util/browser-detector.js";
import nr from "./l10n-manager.js";
const Ee = {
  t: !1,
  i: null,
  m: () => {
    if ((Ee.o(), !Ee.i)) {
      let r = ot.language,
        t = !1;
      e.nn(T.zn) && ((r = e.nn(T.zn)), (t = !0)), (Ee.i = new nr(r, t));
    }
    return Ee.i;
  },
  o: () => {
    Ee.t || (e.u(Ee), (Ee.t = !0));
  },
  destroy: () => {
    (Ee.i = null), (Ee.t = !1);
  }
};
export default Ee;
